import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="container about-container">
        <div className="about-text">
          <h2 className="section-title">Our Story</h2>
          <p className="lead">A family-owned communal dining experience.</p>
          <p>
            At Pyro Pot, we believe that the best moments in life are shared around a warm, bubbling pot of rich broth. Born from generations of family recipes, our authentic broth bases are simmered for hours to extract the deepest flavors—from our nourishing Golden Chicken and Chaoshan-style Beef Bone Broth to our rich Pork Bone Broth and signature House Spicy Pot.
          </p>
          <p>
            Our all-you-can-eat dining experience features only the freshest ingredients—from choice cuts like Angus Ribeye, Short Rib, and thinly sliced Brisket and Pork Belly, to freshly prepared sushi rolls, nigiri, and savory small plates like soup dumplings and takoyaki. Whether you crave the fiery kick of our House Spicy Pot or the comforting richness of our simmered bone broths, every meal here is designed to bring people closer together.
          </p>
          <div className="about-stats">
            <div className="stat">
              <span className="stat-num glow-text">6</span>
              <span className="stat-label">Signature Broths</span>
            </div>
            <div className="stat">
              <span className="stat-num glow-text">9</span>
              <span className="stat-label">Choice Meat Cuts</span>
            </div>
            <div className="stat">
              <span className="stat-num glow-text">AYCE</span>
              <span className="stat-label">All-You-Can-Eat</span>
            </div>
            <div className="stat">
              <span className="stat-num glow-text">3</span>
              <span className="stat-label">Generations of Flavor</span>
            </div>
          </div>
        </div>
        {/* <div className="about-image-wrapper">
          <div className="about-image-placeholder">
            <div className="accent-border"></div>
            <span>Gather 'Round</span>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default About;
